.c1pd0lmg{margin:0;background-color:#fff;padding:0px!important;}
.c1aat93l{color:gray;text-decoration-line:underline;margin:5px 0;display:block;cursor:pointer;}
